// extracted by mini-css-extract-plugin
export default {"headerContainer":"yUFrJRHD+JsvrJTz1qA6Vw==","title":"H2W4bxixRGUv5c3m60mekg==","desc":"H-YK9mqZF6-yTdoeuDqeEw=="};